export default class CreditApplyWindowItem {
  constructor(
    selectedLineItemIds,
    selectedAssignmentIds,
    creditMemoRequest,
    baseFee,
    baseReimbursement,
    notSelectedCreditAmount,
    maxInvoiceAmount,
    allItemsInTheSearchSetAreSelected,
    searchItem,
    action = -1
  ) {
    this.initialize(
      selectedLineItemIds,
      selectedAssignmentIds,
      creditMemoRequest,
      baseFee,
      baseReimbursement,
      notSelectedCreditAmount,
      maxInvoiceAmount,
      allItemsInTheSearchSetAreSelected,
      searchItem,
      action
    );
  }

  async initialize(
    selectedLineItemIds,
    selectedAssignmentIds,
    creditMemoRequest,
    baseFee,
    baseReimbursement,
    notSelectedCreditAmount,
    maxInvoiceAmount,
    allItemsInTheSearchSetAreSelected,
    searchItem,
    action
  ) {
    this.SelectedLineItemIds = selectedLineItemIds;
    this.SelectedAssignmentIds = selectedAssignmentIds;
    this.CreditType = 'Credit Percent';
    this.CreditPercentFee = '';
    this.CreditPercentReimbursement = '';
    this.CreditAmountFee = '';
    this.CreditAmountReimbursement = '';
    this.CreditMemoRequestId = creditMemoRequest.creditMemoRequestId;
    this.LineItemCreditAmount = creditMemoRequest.lineItemCreditAmount;
    this.CurrencyCode = creditMemoRequest.currencyCode;
    this.BaseFee = baseFee;
    this.BaseReimbursement = baseReimbursement;
    this.NotSelectedCreditAmount = notSelectedCreditAmount;
    this.CreditAmountAfter = notSelectedCreditAmount;
    this.MaxInvoiceAmount = maxInvoiceAmount;
    this.AllItemsInTheSearchSetAreSelected = allItemsInTheSearchSetAreSelected;
    this.SearchItem = searchItem;
    this.Action = action;
  }
}
